// extracted by mini-css-extract-plugin
module.exports = {"container":"Investing_container__1heR_","button":"Investing_button__3klz6"};